export default {
	computed: {
		partner() {
			return this.$root.refs.app?.$attrs?.partner;
		},
		partnerName() {
			return this.partner?.profile?.name;
		},
		partnerLogo() {
			return this.partner?.logo?.uri;
		},
	},
};
